import Vue from 'vue';
const stringComponent = (htmlSTR, { datas, id, content }) => {
    const ComponentA = Vue.extend({
        template: htmlSTR,
        data() {
            return {
                ...datas,
                content
            };
        },
        methods: {}
    });
    const instance = new ComponentA();
    return instance.$mount(id);
};
export default stringComponent;
//# sourceMappingURL=stringComponent.js.map